import apiUseCases from "@src/cloud-connect/api";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import store from "@src/reducers/store";

export const createInstallationProcessUseCase = async (formData: FormData) => {
  try {
    const state = store.getState();

    const namespace = state?.yourSlice?.authContext?.customerNamespace;
    const source_id = state.yourSlice.connectionView?.source?.source_id;
    const response = await apiUseCases.createInstallationProcess(
      namespace,
      source_id,
      formData,
    );
    return {
      success: true,
      data: response,
      statusCode: response?.status,
    };
  } catch (error) {
    console.error("createInstallationProcessUseCase error:", error);
    const parsedError = parseAxiosApiError(error, "Failed to ask for approval");
    return {
      success: false,
      error: parsedError.message,
      statusCode: parsedError.status,
    };
  }
};
